import React, { lazy, Suspense } from 'react';
import { Route, useLocation, Navigate, Routes } from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';

import { useTrackPageViews } from 'src/services/analytics';
import { adminRoutes, landlordAuthRoutes, landlordProtectedRoutes, LANDLORD_HOME_PATH } from 'src/routes';
import { ThemeProvider } from 'src/theme';

const LandlordLayout = lazy(() => import('src/components/layout/landlord/LandlordLayout'));
const LandlordInnerLayout = lazy(() => import('src/pages/landlord/LandlordInnerLayout'));
const LandlordOnboardingPage = lazy(() => import('src/pages/landlord/onboard/LandlordOnboardingPage'));
const NotFoundPage = lazy(() => import('src/pages/not-found/NotFound'));

const useSuspenseFallback = () => {
    const { pathname } = useLocation();

    if (pathname.startsWith('/landlord/inner')) {
        return <LandlordLayout isLoading={true} />;
    } else {
        return (
            <ThemeProvider>
                <LinearProgress />
            </ThemeProvider>
        );
    }
};

export default function App() {
    const fallback = useSuspenseFallback();

    useTrackPageViews();

    return (
        <Suspense fallback={fallback}>
            <Routes>
                <Route path="/" element={<Navigate to={LANDLORD_HOME_PATH} />} />
                <Route path="/landlord" element={<Navigate to={LANDLORD_HOME_PATH} />} />
                <Route path="/landlord/inner" element={<Navigate to={LANDLORD_HOME_PATH} />} />

                {/* TODO: Put all landlord auth routes under `/landlord/auth` */}
                {...landlordAuthRoutes}

                <Route path="/landlord/onboard/*" element={<LandlordOnboardingPage />} />

                <Route path="/landlord/inner" element={<LandlordInnerLayout />}>
                    {...landlordProtectedRoutes}
                </Route>

                <Route path="/admin">
                    {...adminRoutes}
                </Route>

                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Suspense>
    );
}